import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Group projects"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Report — Website`}</h3>
    <h1>{`Data as artefact & Data publics`}</h1>
    <p>{`This part of the course consists of two phases leading to different outcomes. In the `}<em parentName="p">{`data as artefact`}</em>{` phase, students learnt how to make use of online data to study social and cultural phenomena. In a question-driven process, each group explored a specific topic, designed protocols for data collection, analysed data and produced research findings using data visualisations.`}</p>
    <p>{`By identifying the mediating platform/services and finding ways to repurpose their affordances, students created the printed reports you can browse in this section.`}</p>
    <p>{`In the `}<em parentName="p">{`data public`}</em>{` phase, students turned part of the research carried out in the previous phase into discursive communication artifacts that expose, show or make known the critical aspects of the subjects researched to a specific audience. The aim was to design communication artifacts that invited the public to reflect on the explored subjects. Students reflected on the meaning and agency of the notion of "the public": how different groups mobilize around various issues and how data can play a central role in the process of forming publics. `}</p>
    <p>{`The result of the phase is a website designed to illustrate students’ view on the chosen topic, by leveraging on digital and interactive techniques.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      